import { TaskStatus } from '@prisma/client';
import { useContext } from 'react';

import { ServiceRequestTaskProps } from '../../../types';
import { ServiceRequestStepCompletionContext } from './service-request-step-completion-context';

interface ServiceRequestTaskCompletionProps {
  task: ServiceRequestTaskProps['task'];
  context: ServiceRequestTaskProps['context'];
}

export const ServiceRequestTaskCompletion = ({
  task,
  context,
}: ServiceRequestTaskCompletionProps) => {
  const { enabled, responses, isLoading, error } = useContext(
    ServiceRequestStepCompletionContext
  );
  if (
    !enabled ||
    task.status !== TaskStatus.COMPLETED ||
    !task.workflowDefinitionStepId
  )
    return null;
  const executionId =
    task.taskGroup?.workflowExecutionId ?? context.workflowExecution?.id;
  if (!executionId || error) return null;
  if (isLoading)
    return (
      <p
        className="txt-extra-small-regular text-text-secondary"
        aria-busy="true"
      >
        Loading completion details…
      </p>
    );
  const completion = responses
    ?.find((response) => response.workflowExecutionId === executionId)
    ?.completions.find(
      (step) => step.stepDefinitionId === task.workflowDefinitionStepId
    );
  if (!completion) return null;
  return (
    <p className="txt-extra-small-regular text-text-secondary">
      {completion.actorName
        ? `${completion.action === 'APPROVED' ? 'Approved' : 'Completed'} by ${completion.actorName}`
        : 'Completion details unavailable'}
    </p>
  );
};
